import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
    resetLink: null,
    setLinkConfig: ['en', 'fr'],
    setCasConfig: ['CASConfig'],
    setAppConfig: ['appConfig']
})

export const LinkConfigTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
    en: {},
    fr: {},
    CASConfig: {},
    appConfig: {
    }
})

/* ------------- Reducers ------------- */
export const linkResetLink = (state) => INITIAL_STATE

export const linkSetLinkConfig = (state, { en, fr }) =>
    state.merge({ en: en, fr: fr })

export const linkSetCASConfig = (state, { CASConfig }) =>
    state.merge({ CASConfig: CASConfig })

export const linkSetAppConfig = (state, { appConfig }) =>
    state.merge({ appConfig: appConfig })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.RESET_LINK]: linkResetLink,
    [Types.SET_LINK_CONFIG]: linkSetLinkConfig,
    [Types.SET_CAS_CONFIG]: linkSetCASConfig,
    [Types.SET_APP_CONFIG]: linkSetAppConfig
})